import * as React from "react";

import { cn } from "@/lib/utils";

const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { glowing?: string }
>(({ className, glowing, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-xl border bg-card text-card-foreground shadow-none",
      glowing
        ? `relative
appearance-none
overflow-hidden
outline-none
p-[1.5px]
m-0
rounded-xl
text-card-foreground
shadow-[0_0_2px_0_rgb(0_0_0/0.05)]
shadow-sky-200
dark:shadow-sky-900
before:absolute
before:w-full
before:h-[200%]
before:inset
before:-top-[50%]
before:rounded-[inherit]
before:overflow-hidden
before:bg-[conic-gradient(var(--tw-gradient-stops))]
before:from-sky-100
before:from-70%
before:to-sky-950
dark:before:from-sky-950
dark:before:from-70%
dark:before:to-sky-100
before:blur-xl
before:animate-[spin_linear_4s_infinite]
[&>div]:relative
[&>div]:z-[1]
[&>div:first-child]:rounded-t-[inherit]
[&>div:last-child]:rounded-b-[inherit]
[&>div]:overflow-hidden
[&>div]:bg-card
[&>div]:transition-colors
[&>div]:duration-300
[&>div]:backdrop-blur-3xl`
        : "p-[1.5px]",
      className
    )}
    {...props}
  />
));
Card.displayName = "Card";

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6", className)}
    {...props}
  />
));
CardHeader.displayName = "CardHeader";

const CardTitle = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("font-semibold leading-none tracking-tight", className)}
    {...props}
  />
));
CardTitle.displayName = "CardTitle";

const CardDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
));
CardDescription.displayName = "CardDescription";

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
));
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props}
  />
));
CardFooter.displayName = "CardFooter";

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
};
